module.exports = __webpack_public_path__ + "static/media/proj10_img1.e0b224b3.jpg";